import React from 'react';

import { connect } from 'react-redux';
import s from './style.module.css';
import * as Icon from 'react-feather';
import moment from 'moment';

import Button from '../button';

import { updatePageNumber } from '../../actions/global-actions';

class Header extends React.Component {

	handleNext(e) {
		window.open("https://www.booker25.com/contact/#pardot-form");
	}

	render(props) {
		let datetime;
		if(this.props.date && this.props.timeslot.start) {
			datetime = 	<span>{this.props.date},&nbsp;{moment(this.props.timeslot.start).format("HH:mm")} - {moment(this.props.timeslot.end).format("HH:mm")}</span>
		} else {
			datetime = <span>Select time and date</span>
		}

		let fristStepNumber;
		if(this.props.active === 1) {
			fristStepNumber = <span className={s.stepPageNumber}>1</span>
		} else {
			fristStepNumber = <Icon.Check  className={`${s.Checkicon}`} />
		}

		let secondStepNumber;
		if(this.props.active >= 1) {
			secondStepNumber = <span className={s.stepPageNumber}>2</span>
		} else {
			secondStepNumber = <Icon.Check  className={`${s.Checkicon}`} />
		}

		return (
			<div className={s.stepsGridWrapper}>
				<div className={s.stepsWrapper}>
					<div className={ `${s.stepWrapper} ${s.pointerWrapper} ${this.props.active === 1 ? s.mActive : ''}`} onClick={this.props.onClick}>
						<div className={ ` ${s.checkMark} ${this.props.active > 1 ? s.mActiveCheck : ''}` }>
							{fristStepNumber}
						</div>
						<div className={s.pageDescriptionWrapper}>
							<div className={s.pageHeadline}>Time and Date</div>
							<div className={s.pageDescription}>{datetime}</div>
						</div>
						<Icon.ChevronRight className={s.icon} size="20" />
					</div>
					<div className={s.lineMobile}></div>
					<div className={ `${s.stepWrapper} ${this.props.active === 2 ? s.mActive: ''}` }>
						<div className={ ` ${s.checkMark} ${this.props.active > 2 ? s.mActiveCheck : ''}` }>
							{secondStepNumber}
						</div>
						<div className={s.pageDescriptionWrapper}>
							<div className={s.pageHeadline}>Demo details</div>
							<div className={s.pageDescription}>Your industry and use case</div>
						</div>
						<Icon.ChevronRight  className={s.icon} size="20" />
					</div>
				</div>
				{this.props.page === 1 ?
					<div className={s.btnContactForm}>
						<p className={s.requestTimeslot}>Can't find a time to suit you? <br></br>Get in touch to request an alternative timeslot:</p>
						<div>
							<a className={s.btn} href="https://www.gen25.com/en/contact/#contact-form">Request Timeslot</a>
						</div>
					</div>
				: ""
				}
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	const { 
		date,
		timeslot,
	} = state.page2;
	const { page, nextBtn } = state.global;
	return { date, timeslot, page, nextBtn };
}

export default connect(mapStateToProps, {updatePageNumber})(Header);
